import React from 'react';
import { ChatbotMessageLimits } from '../../components/dashboard/ChatbotMessageLimits';

export default function ChatbotLimitsSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Chatbot Limits</h2>
        <p className="text-gray-400">Configure message limits for your chatbot</p>
      </div>

      <ChatbotMessageLimits />

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">About Message Limits</h3>
        <div className="space-y-4 text-gray-300">
          <p>
            Message limits help control the length of conversations with your chatbot. Setting appropriate limits can:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Prevent excessively long conversations that may degrade performance</li>
            <li>Encourage users to start new conversations for new topics</li>
            <li>Optimize your AI usage and costs</li>
            <li>Improve the overall user experience</li>
          </ul>
          <p>
            When a conversation reaches the message limit, the chatbot will automatically suggest starting a new conversation.
          </p>
        </div>
      </div>
    </div>
  );
}